import React from 'react'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import PropTypes from 'prop-types'
import useCitrusBanners from '../../hooks/useCitrusBanners'
import CitrusBanners from './CitrusBanners'

const CitrusBannersWrapper = ({ searchTerm, categoryName, placement, clpPosition }) => {
  const banners = useCitrusBanners(searchTerm, categoryName, placement)
  if (!banners || banners.length === 0) {
    return null
  }
  return (
    <ErrorBoundary>
      <aside className='xs-row xs-auto--negative'>
        <div className='xs-hidden lg-block lg-3' />
        <div className='xs-block xs-12 lg-9'>
          <CitrusBanners
            banners={banners}
            searchTerm={searchTerm}
            categoryName={categoryName}
            placement={placement}
            clpPosition={clpPosition}
          />
        </div>
      </aside>
    </ErrorBoundary>
  )
}

CitrusBannersWrapper.propTypes = {
  searchTerm: PropTypes.string,
  categoryName: PropTypes.string,
  placement: PropTypes.string,
  clpPosition: PropTypes.string
}

CitrusBannersWrapper.defaultProps = {
  searchTerm: null,
  categoryName: '',
  placement: '',
  clpPosition: 'top'
}

export default CitrusBannersWrapper
